import { SegmentedControl, useMantineColorScheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';

import type { MantineColorScheme } from '@mantine/core';

export default function AppearanceSection() {
    const { t } = useTranslation('settings');
    const { colorScheme, setColorScheme } = useMantineColorScheme();

    return (
        <DialogBox
            label={t('appearance.title')}
            description={t('appearance.description')}
            classNames="p-4"
        >
            <SegmentedControl
                aria-label={t('appearance.title')}
                value={colorScheme}
                onChange={(next) => setColorScheme(next as MantineColorScheme)}
                data={[
                    { label: t('appearance.light'), value: 'light' },
                    { label: t('appearance.dark'), value: 'dark' },
                    { label: t('appearance.auto'), value: 'auto' },
                ]}
            />
        </DialogBox>
    );
}
